var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssignmentsMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7812 7.43359C13.7812 3.71484 10.7188 0.652344 7 0.652344C3.25391 0.652344 0.21875 3.71484 0.21875 7.43359C0.21875 11.1797 3.25391 14.2148 7 14.2148C10.7188 14.2148 13.7812 11.1797 13.7812 7.43359ZM6.20703 11.043C6.04297 11.207 5.74219 11.207 5.57812 11.043L2.73438 8.19922C2.57031 8.03516 2.57031 7.73438 2.73438 7.57031L3.36328 6.96875C3.52734 6.77734 3.80078 6.77734 3.96484 6.96875L5.90625 8.88281L10.0078 4.78125C10.1719 4.58984 10.4453 4.58984 10.6094 4.78125L11.2383 5.38281C11.4023 5.54688 11.4023 5.84766 11.2383 6.01172L6.20703 11.043Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignmentsMenuIcon);
export default __webpack_public_path__ + "static/media/AssignmentsMenuIcon.034e20b3.svg";
export { ForwardRef as ReactComponent };